"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decorateSelection = void 0;
const core_1 = require("@tiptap/core");
const state_1 = require("@tiptap/pm/state");
const view_1 = require("@tiptap/pm/view");
exports.decorateSelection = core_1.Extension.create({
    name: 'decorateSelection',
    addProseMirrorPlugins() {
        return [
            new state_1.Plugin({
                props: {
                    decorations(state) {
                        const selection = state.selection;
                        if (selection.empty)
                            return;
                        return view_1.DecorationSet.create(state.doc, [
                            view_1.Decoration.inline(selection.from, selection.to, { class: 'selected-text' }),
                        ]);
                    },
                },
            }),
        ];
    },
});
//# sourceMappingURL=decorateSelection.js.map